export function removeDotfromTagName(tagName: string): string {
  return (tagName || "")?.split(".")?.slice(-1)?.[0] || "";
}
